<template>
  <div class="CreatvallStyle" v-infinite-scroll="onLoadMorePhoto"
      infinite-scroll-distance="200">
    <h2 class="title">照片墙</h2>
    <el-carousel
      :interval="4000"
      indicator-position="none"
      type="card" v-on:change="changeHandler">
      <el-carousel-item
        v-for="(item, index) in photoList"
        :key="index"
      >
        <img class="photo_wall_img" :src="item.imageUrl" v-bind:alt="item.describes">
      </el-carousel-item>
    </el-carousel>

    <ul class="infinite-list"
      
      style="overflow:auto">
      <li v-for="(item, index) in photoList" :key="index" class="infinite-list-item">
        <el-upload
          class="avatar-uploader"
          action="string"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :http-request="UploadImage"
          :data="{editIndex: index}"
        >
          <img
            v-if="item.imageUrl"
            style="width: 200px; height: 200px"
            :src="item.imageUrl"
            fit="cover" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>

        <div>
          
          <el-link type="primary" v-if="item.originImgUrl != item.imageUrl" icon="el-icon-edit" @click="onUpdate(item.linkid, index)">重新上传</el-link>
          <el-link type="info" v-else icon="el-icon-edit" @click="onDisableUpdate(item.linkid, index)">重新上传</el-link>
          <el-link icon="el-icon-delete" @click="onDeletPhoto(item.linkid, index)">删除</el-link>
        </div>
      </li>

      <li class="infinite-list-item">
        <el-upload
          class="avatar-uploader"
          action="string"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :http-request="UploadImage"
        >
          <el-image
            v-if="imageUrl"
            style="width: 200px; height: 200px"
            :src="imageUrl"
            fit="cover"></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div>
          <el-link icon="el-icon-edit" @click="onSubmit">上传</el-link>
        </div>
      </li>
    </ul>
    <!-- <el-form ref="ruleForm" label-width="100px" class="CreatVhallForm">
      <el-form-item label="照片墙图片">
        <el-upload
          class="avatar-uploader"
          action="string"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :http-request="UploadImage"
        >
          <img :src="imageUrl" class="avatar">
        </el-upload>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">立即保存</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form> -->
  </div>
</template>

<script>
import { actionuploadImg } from '@/api/img'
import { savePublisher, queryActionList2, deleteActionRow, updatPublisher } from '@/api/sysinfo'
import { imageTypes } from '../../../../common/utils/constant'
import { showGlobalLoading, hideGlobalLoading, toastSuccess, toastError, showConfirm, toastInfo } from '../../../../common/utils/ui'
export default {
  name: 'PhotoWall',
  data () {
    return {
      imageUrl: '',
      photoList: []
    }
  },
  created () {
    this.allPageNum = 0
    this.pageNow = 1
    this.editPhotoIndex = -1 // 编辑的索引
    this.isLoading = false
    this.hasMore = true
    this.queryPhotos()
  },
  methods: {
    // 图片上传
    handleAvatarSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    // 文件提交
    UploadImage (param) {
      const formData = new FormData()
      formData.append('file', param.file)
      this.editPhotoIndex = (param.data || {}).editIndex
      actionuploadImg(formData).then(response => {
        if (this.editPhotoIndex) {
          const newItem = Object.assign({}, this.photoList[this.editPhotoIndex])
          newItem.imageUrl = response
          this.photoList.splice(this.editPhotoIndex, 1, newItem)
        } else {
          this.imageUrl = response
        }
      })
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isLt2M
    },

    onSubmit () {
      if (!this.imageUrl) {
        return toastError('请选择图片')
      }

      const param = {
        position: imageTypes.photo_wall,
        imageUrl: this.imageUrl,
        columnIndex: 0, // 固定0
        describes: '照片墙'
      }

      showGlobalLoading()
      savePublisher(param).then((ret) => {
        if (ret.code === '200') {
          toastSuccess('保存成功')
          
          const photoItem = this.photoList[this.photoList.length - 1]
          const newItem = {
            linkid: ret.data || photoItem.linkid + 1,
            position: imageTypes.photo_wall,
            imageUrl: this.imageUrl,
            originImgUrl: this.imageUrl
          }

          this.photoList.push(newItem)

          this.imageUrl = ''
        } else {
          toastError('保存失败,请稍后再试')
        }
        hideGlobalLoading()
      }).catch(err => {
        console.error(err)
        hideGlobalLoading()
      })
    },

    // 图片滑动事件监听
    changeHandler (newIndex, oldIndex) {
      if (newIndex === this.photoList.length - 1) {
        this.onLoadMorePhoto()
      }
    },

    queryPhotos () {
      if (this.isLoading) {
        return
      }
      const param = {
        position: imageTypes.photo_wall,
        currentIndex: this.pageNow
      }
      this.isLoading = true
      queryActionList2(param).then(ret => {
        const data = ret.data || {}
        const list = data.list || []
        list.forEach(item => {
          item.originImgUrl = item.imageUrl
        })
        if (this.pageNow === 1) {
          this.photoList = list
        } else {
          this.photoList = this.photoList.concat(list)
        }
        this.pageNow++
        this.isLoading = false
        if (list.length === 0) {
          this.hasMore = false
        }
      }).catch(err => {
        console.error(err)
        this.isLoading = false
      })
    },

    // 加载更多
    onLoadMorePhoto () {
      if (!this.hasMore) {
        return
      }
      this.queryPhotos()
    },

    onUpdate (photoId, index) {
      showConfirm('确定要修改该图片吗?').then(instace => {
        const updteItem = this.photoList[index]
        const param = {
          position: imageTypes.photo_wall,
          imageUrl: updteItem.imageUrl,
          columnIndex: 0, // 固定0
          describes: '照片墙',
          linkid: updteItem.linkid
        }
        showGlobalLoading()
        updatPublisher(param).then(ret => {
          if (ret.code === '200') {
            toastSuccess('修改成功')
          } else {
            toastError('图片修改失败,请稍后再试')
          }
          hideGlobalLoading()
        }).catch(err => {
          console.error(err)
          toastError('图片删除失败,请稍后再试')
          hideGlobalLoading()
        })
      })
    },

    onDisableUpdate () {
      toastInfo('请先点击照片选择需要修改后的图片')
    },

    // 删除照片
    onDeletPhoto (photoId, index) {
      showConfirm('确定要删除该图片吗?').then(instace => {
        const param = {
          position: imageTypes.photo_wall,
          imageUrl: this.imageUrl,
          columnIndex: 0, // 固定0
          describes: '照片墙',
          linkId: photoId
        }
        showGlobalLoading()
        deleteActionRow(param).then(ret => {
          if (ret.code === '200') {
            toastSuccess('删除成功')
            this.photoList.splice(index, 1)
          } else {
            toastError('图片删除失败,请稍后再试')
          }
          hideGlobalLoading()
        }).catch(err => {
          console.error(err)
          toastError('图片删除失败,请稍后再试')
          hideGlobalLoading()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 208px;
    text-align: center;
    border: 1px dotted;
    line-height: 200px;
    vertical-align: text-bottom;
}
.title {
  line-height: 40px;
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 20px;
}
.photo_wall_img {
  height: 300px;
  width: auto;
}
.infinite-list-item {
  display: inline-block;
  margin: 10px;
  text-align: center;
}
.infinite-list {
  margin-top: 20px;
}
.CreatvallStyle {
    overflow: auto;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/views/SysManager/ExhibitionInfo/PhotoWall/index.vue